/**
 * Facebook 广告投放
 */

export default function ({ app, store }) {
  // eslint-disable-next-line
  app.head.htmlAttrs.id = `style__${store.state.betterme}`;

  // if (store.state.betterme === 'bettermeedu') {
  //   app.head.meta.push({
  //     name: 'og:image',
  //     content: 'https://download-pa-s3.thethinkacademy.com/frontend/2025/02/20/7fguiwsgoj.png',
  //   });
  // } else {
  //   app.head.meta.push({
  //     name: 'og:image',
  //     content: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/common/brand-logo-square.jpg',
  //   });
  // }

  // 客户端环境不执行
  if (process.client) return;

  if (store.state.locale === 'sg') {
    // 新分facebook广告投放
    app.head.meta.push({
      name: 'facebook-domain-verification',
      content:
        process.env.clientType === 'web'
          ? 'wl3x609789xm0nj0jq7xg30e5wsc9b'
          : 'dzt9pjcsjb2soei9g26xltyxfryqv6',
    });
  }

  if (store.state.locale === 'my') {
    // 新分facebook广告投放
    app.head.meta.push({
      name: 'facebook-domain-verification',
      content: 'cpjet81tio7x04azyp35io4q7wpp8v',
    });
  }
  if (store.state.locale === 'hk') {
    // 香港facebook广告投放
    app.head.meta.push({
      name: 'facebook-domain-verification',
      content: 'ox9pjeq1f4pz1ahwvpi7olcoyl7p1q',
    });
  }
  if (store.state.locale === 'fr') {
    // 法国facebook广告投放
    app.head.meta.push({
      name: 'facebook-domain-verification',
      content: 'mf8xowk488331wt4h3mh8icvxzh31v',
    });
  }
}
